<template>
  <!-- 挽留弹窗 -->
  <nd-dialog
    v-model="value"
    :footer="false"
    class="detention-dialog"
  >
    <div class="detention-dialog-content">
      <div class="detention-title">
        <p>填写简单的信息，最高即可获得5万额度！真的要放弃吗？</p>
      </div>

      <ul class="giveup">
        <li
          v-for="(item, index) in giveUpReason"
          :key="index"
          @click="giveUp(index + 1)"
        >
          {{ item }}
        </li>
      </ul>

      <button
        class="continue"
        @click="$emit('on-close')"
      >继续提现</button>
    </div>
  </nd-dialog>

</template>
<script>
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      giveUpReason: [
        '不想拿钱了',
        '操作不便，不想继续',
        '手边资料不全，无法完成'
      ]
    }
  },
  methods: {
    // 放弃激活额度
    giveUp (index) {
      if (this.isAndroid && hasNativeMethod('exit')) {
        return jsBridge('exit')
      }

      this.detentionVisible = false
      this.$nextTick(() => {
        this.$router.back()
      })
    }
  }
}
</script>


<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.detention-dialog {
  .detention-title {
    margin: 0 58px;
    text-align: center;
    font-size: 36px;
    line-height: 50px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    padding-bottom: 34px;
    border-bottom: 1px solid #eeeeee;
  }

  .giveup {
    li {
      height: 110px;
      line-height: 110px;
      text-align: center;
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: @fc3;
      border-bottom: 1px solid #eeeeee;
    }
  }

  .continue {
    border: 0px solid transparent;
    height: 160px;
    line-height: 160px;
    text-align: center;
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: @theme;
    width: 100%;
    -webkit-appearance: none;
    outline: none;
    background-color: #ffffff;
  }
}
</style>